<template>
  <div class="antialiased">

    <Sidebar/>


    <div class="page">

      <Header :showSearchField="false" />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Riwayat Persetujuan
                </h2>
              </div>
            </div>
          </div>

          <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

          <Nodata v-if="!loading && data.length == 0"/>

          <div class="box" v-if="!loading && data.length > 0">
              <div class="card">
                <div class="table-respon sive">
                  <table class="table table-vcenter table-hover card-table table-striped table-control">

                    <thead>
                      <tr class="text-muted">
                        <th>From</th>
                        <th>Subject</th>
                        <th>Description</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in data" :key="i">
                        <td>{{row.user_name}}</td>
                        <td>{{row.subject}}</td>
                        <td v-html="row.description"></td>
                        <td>
                          <span :class="'badge '+statusClass[row.status]">{{row.status}}</span>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
          </div>

          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-12 col-md-auto text-center">
                <button class="btn btn-outline-primary mr-3" @click="() => _pageChange(-1)">
                  Prev
                </button>
                <button class="btn btn-outline-primary" @click="() => _pageChange(+1)">
                  Next
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "Approval",
  data() {
    return {
        auth: {},
        loading: true,
        data: [],
        page: 1,
        next: true,
        statusClass:{
          approved: "bg-green",
          rejected: "bg-danger",
          pending: "bg-orange",
        }
    };
  },

  mixins: [helper],

  methods: {
      _get(){
        this.loading = true
        this.axios.get(`approval_requests/history?page=${this.page}`).then(res => {
          this.loading = false;

          if (res.data.data.length === 0) {
            this.next = false;
          } else {
            this.data = res.data.data;
            this.next = true;
          }
        }).catch( err => {
          this.loading = false;
          this.onError(err)
        });
      },

      _add(){
        this.form.config = {view: true, title: 'Tambah Brand'}
        this.form.data = null
        this.form.action = (formData) => {

          this.axios.post('brand', formData).then(res =>{

            this._get({silent: true})

            this.toast('Berhasil ditambahkan');
            this.form.config.view = false;
          }).catch( err => {
            this.onError(err);
            this.form.isSubmit = false;
          });
        }
      },

      _edit(data){
        this.form.config = {view: true, title: 'Edit Brand'}
        this.form.data = data
        this.form.action = (formData) => {

          this.axios.put('brand/'+data.id+'?per_page='+this.paginate.perPage+'&page='+this.paginate.currentPage, formData).then(res =>{

            this._get({silent: true})

            this.toast('Berhasil diperbarui');
            this.form.config.view = false;
          }).catch( err => {
            this.onError(err);
            this.form.isSubmit = false;
          });
        }
      },

      _delete(id){
        this.confirm.id = id
        this.confirm.title = 'Yakin ingin menghapus data brand ini?'
        this.confirm.action = () => {

          this.axios.delete('brand/'+id+'?per_page='+this.paginate.perPage+'&page='+this.paginate.currentPage).then(res => {
            this.toast('Berhasil dihapus');
            this._get({silent: true})
            this.confirm.id = null
          }).catch( err => {
            this.onError(err);
            this.confirm.isSubmit = false
          });

        }
      },

      _pageChange(page){
        if (page < 0 && this.page === 1) {
          return
        }

        if (page > 0 && !this.next) {
          return
        }

        this.page += page

        this._get()
      },

  },

  mounted(){
    this.auth = JSON.parse(localStorage.user)
    this._get()
  }

};
</script>

<style lang="scss" scoped>
  hr{
    margin: 0 !important
  }
</style>
